/* WAKA cart — drawer + cart page interactivity (vanilla, no Dawn deps).
   - Header bag icon opens the drawer (falls back to /cart link without JS).
   - Qty / remove on drawer + cart page → /cart/change.js, then re-render via
     the Section Rendering API (drawer = static section 'cart-drawer'; page
     sections discovered from [data-section-id]).
   - PDP add-to-cart (form#WakaProductForm) → /cart/add.js with the main
     variant plus any checked kit add-ons (fixes kit toggles never reaching
     the cart), then opens the drawer.
   Open state lives on body.wk-cart-open so re-renders never close the drawer. */
(function(){
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;

  function $(sel, ctx){ return (ctx || document).querySelector(sel); }
  function drawerRoot(){ return $('[data-wk-drawer-root]'); }

  /* ---- open / close ------------------------------------------------ */
  function openDrawer(){ if (drawerRoot()) document.body.classList.add('wk-cart-open'); }
  function closeDrawer(){ document.body.classList.remove('wk-cart-open'); }

  document.addEventListener('click', function(e){
    var toggle = e.target.closest('[data-wk-cart-toggle]');
    if (toggle && drawerRoot()){ e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-wk-cart-close]')){ closeDrawer(); return; }
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && document.body.classList.contains('wk-cart-open')) closeDrawer();
  });

  /* ---- section re-rendering ---------------------------------------- */
  function pageSectionIds(){
    var ids = [];
    ['[data-wk-cart-items]', '[data-wk-cart-footer]'].forEach(function(sel){
      var el = $(sel);
      if (el && el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }
  function sectionsParam(){
    var ids = pageSectionIds();
    if (drawerRoot()) ids.push('cart-drawer');
    return ids;
  }
  function applySections(sections){
    if (!sections) return;
    Object.keys(sections).forEach(function(id){
      var html = sections[id];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'cart-drawer'){
        var freshDrawer = doc.querySelector('[data-wk-drawer-root]');
        var cur = drawerRoot();
        if (freshDrawer && cur) cur.replaceWith(freshDrawer);
        return;
      }
      var target = $('[data-section-id="' + id + '"] .js-contents');
      var fresh = doc.querySelector('.js-contents');
      if (target && fresh) target.innerHTML = fresh.innerHTML;
    });
  }
  function updateBadge(count){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = count > 0 ? count : '';
      el.toggleAttribute('hidden', !(count > 0));
    });
  }

  /* ---- qty / remove -------------------------------------------------- */
  function setBusy(on){
    busy = on;
    var dr = drawerRoot(); var pg = $('[data-wk-cart-items]');
    if (dr) dr.classList.toggle('wk-cart-busy', on);
    if (pg) pg.classList.toggle('wk-cart-busy', on);
  }
  function changeLine(line, quantity, errorEl){
    if (busy) return;
    setBusy(true);
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: sectionsParam() })
    })
      .then(function(r){ return r.json().then(function(d){ return { ok: r.ok, data: d }; }); })
      .then(function(res){
        if (!res.ok){
          if (errorEl) errorEl.textContent = res.data.description || res.data.message || 'Could not update the cart.';
          return;
        }
        applySections(res.data.sections);
        updateBadge(res.data.item_count);
        document.dispatchEvent(new CustomEvent('waka:cart', { detail: res.data }));
      })
      .catch(function(){ if (errorEl) errorEl.textContent = 'Could not update the cart.'; })
      .finally(function(){ setBusy(false); });
  }

  document.addEventListener('click', function(e){
    var qtyBtn = e.target.closest('[data-wk-qty]');
    if (qtyBtn){
      var row = qtyBtn.closest('[data-wk-line]');
      var n = row ? row.querySelector('.qty .n') : null;
      var current = n ? parseInt(n.textContent, 10) || 1 : 1;
      var next = Math.max(0, current + parseInt(qtyBtn.dataset.wkQty, 10));
      changeLine(parseInt(qtyBtn.dataset.line, 10), next, row ? row.querySelector('[data-wk-line-error]') : null);
      return;
    }
    var removeBtn = e.target.closest('[data-wk-remove]');
    if (removeBtn){
      var rrow = removeBtn.closest('[data-wk-line]');
      changeLine(parseInt(removeBtn.dataset.line, 10), 0, rrow ? rrow.querySelector('[data-wk-line-error]') : null);
    }
  });

  /* ---- Viento seeds inside the drawer: viento.js handles the ask
     (global [data-viento-seed] binding); we only step the drawer aside. */
  document.addEventListener('click', function(e){
    if (e.target.closest('[data-wk-drawer] [data-viento-seed]')) closeDrawer();
  });

  /* ---- PDP add-to-cart (main variant + checked kit add-ons) ---------- */
  var form = document.getElementById('WakaProductForm');
  if (form){
    form.addEventListener('submit', function(e){
      if (!drawerRoot()) return; // no drawer in the DOM → keep native POST → /cart
      e.preventDefault();
      if (busy) return;
      var items = [];
      var vid = document.getElementById('WakaVariantId');
      if (vid && vid.value) items.push({ id: parseInt(vid.value, 10), quantity: 1 });
      form.querySelectorAll('.kit-toggle:checked').forEach(function(t){
        if (t.dataset.id) items.push({ id: parseInt(t.dataset.id, 10), quantity: 1 });
      });
      if (!items.length) return;
      setBusy(true);
      var cta = document.getElementById('WakaCta');
      if (cta) cta.classList.add('wk-cart-busy');
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items, sections: ['cart-drawer'] })
      })
        .then(function(r){ return r.json().then(function(d){ return { ok: r.ok, data: d }; }); })
        .then(function(res){
          if (!res.ok){
            showFormError(form, res.data.description || res.data.message || 'Could not add to cart.');
            return;
          }
          applySections(res.data.sections);
          return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function(r){ return r.json(); })
            .then(function(cart){
              updateBadge(cart.item_count);
              var label = $('[data-wk-count-label]');
              if (label) label.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
              openDrawer();
              document.dispatchEvent(new CustomEvent('waka:cart', { detail: cart }));
            });
        })
        .catch(function(){ showFormError(form, 'Could not add to cart.'); })
        .finally(function(){
          setBusy(false);
          if (cta) cta.classList.remove('wk-cart-busy');
        });
    });
  }
  /* Shared with the discount block below so it can re-render in place. */
  window.WakaCart = { sectionsParam: sectionsParam, applySections: applySections, updateBadge: updateBadge };

  function showFormError(formEl, msg){
    var err = formEl.querySelector('.buy-error');
    if (!err){
      err = document.createElement('p');
      err.className = 'buy-error small';
      err.setAttribute('role', 'alert');
      err.style.color = '#C0492B';
      err.style.marginTop = '10px';
      var ctaEl = formEl.querySelector('.buy-cta');
      (ctaEl && ctaEl.parentNode) ? ctaEl.parentNode.insertBefore(err, ctaEl.nextSibling) : formEl.appendChild(err);
    }
    err.textContent = msg;
  }
})();

/* ---------------------------------------------------------------------------
   Discount code entry (cart page + drawer)
   Primary path: POST /cart/update.js with `discount` (the Ajax Cart API's
   discount-code field). The cart and drawer re-render in place, so the drawer
   stays open and the shopper sees the chip, the discounted line and the new
   total straight away. The response's discount_codes[].applicable tells us
   whether Shopify accepted the code, so no redirect round-trip is needed.
   Fallback: if that request fails or the response has no discount_codes, use
   the /discount/CODE route (attaches the code to the session, redirects back);
   the attempted code is stashed in sessionStorage so we can report the result.
--------------------------------------------------------------------------- */
(function () {
  var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function redirectApply(code) {
    try { sessionStorage.setItem('wkDiscountTried', code); } catch (e) {}
    var back = window.location.pathname + window.location.search;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(back);
  }

  // Report into whichever box the shopper used, found again after re-render.
  function reportInPlace(inDrawer, text, ok) {
    var scope = inDrawer ? document.querySelector('[data-wk-drawer-root]') : document.querySelector('[data-wk-cart-footer]');
    var roots = (scope || document).querySelectorAll('[data-wk-discount]');
    roots.forEach(function (r) {
      message(r, text);
      var el = r.querySelector('[data-wk-discount-msg]');
      if (el) el.classList.toggle('ok', !!ok);
    });
  }

  function apply(root) {
    var input = root.querySelector('[data-wk-discount-input]');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) {
      message(root, 'Enter a code first.');
      input.focus();
      return;
    }
    var WC = window.WakaCart;
    if (!window.fetch || !WC) { redirectApply(code); return; }

    var inDrawer = !!root.closest('[data-wk-drawer-root]');
    var btn = root.querySelector('[data-wk-discount-apply]');
    if (btn) btn.disabled = true;
    message(root, 'Applying…');

    // Keep codes already on the cart: `discount` replaces the whole list.
    fetch(rootUrl + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var existing = (cart.discount_codes || [])
          .filter(function (d) { return d.applicable && d.code.toUpperCase() !== code.toUpperCase(); })
          .map(function (d) { return d.code; });
        return fetch(rootUrl + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: existing.concat(code).join(','), sections: WC.sectionsParam() })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('update failed'); return r.json(); })
      .then(function (res) {
        if (!res.discount_codes) { redirectApply(code); return; }
        var hit = res.discount_codes.filter(function (d) { return d.code.toUpperCase() === code.toUpperCase(); })[0];
        WC.applySections(res.sections);
        if (typeof res.item_count === 'number') WC.updateBadge(res.item_count);
        document.dispatchEvent(new CustomEvent('waka:cart', { detail: res }));
        if (hit && hit.applicable) {
          reportInPlace(inDrawer, 'Code applied.', true);
        } else {
          reportInPlace(inDrawer, '“' + code + '” could not be applied to this cart. Check the code, or whether it covers the items you have.', false);
          // Leave the rejected code in the box so it can be corrected.
          var scope = inDrawer ? document.querySelector('[data-wk-drawer-root]') : document;
          var fresh = scope && scope.querySelector('[data-wk-discount-input]');
          if (fresh) fresh.value = code;
        }
      })
      .catch(function () { redirectApply(code); })
      .finally(function () { if (btn) btn.disabled = false; });
  }

  function message(root, text) {
    var el = root.querySelector('[data-wk-discount-msg]');
    if (!el) return;
    el.textContent = text;
    el.hidden = !text;
  }

  // Read and clear the marker ONCE per bind pass, then hand the value to every
  // discount box. The cart page and the drawer both render one, and clearing it
  // per-box meant whichever bound first swallowed the message - on the cart page
  // that happens to be the visible field, but in the drawer it would not be.
  function takeTried() {
    var tried = null;
    try {
      tried = sessionStorage.getItem('wkDiscountTried');
      sessionStorage.removeItem('wkDiscountTried');
    } catch (e) {}
    return tried;
  }

  function reportResult(root, tried) {
    if (!tried) return;
    var applied = (root.getAttribute('data-wk-applied') || '').split('|').filter(Boolean);
    var hit = applied.some(function (t) { return t === tried.trim().toUpperCase(); });
    message(root, hit
      ? 'Code applied.'
      : '“' + tried + '” could not be applied to this cart. Check the code, or whether it covers the items you have.');
    if (hit) root.querySelector('[data-wk-discount-msg]').classList.add('ok');
  }

  // Apply / Enter are handled by delegation on document, not bound per box.
  // The drawer is swapped out wholesale (replaceWith) after every add-to-cart
  // and qty change, so per-element listeners died with the old node and the
  // drawer's Apply button silently did nothing. Delegation survives re-renders.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wk-discount-apply]');
    if (!btn) return;
    var root = btn.closest('[data-wk-discount]');
    if (root) { e.preventDefault(); apply(root); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('[data-wk-discount-input]');
    if (!input) return;
    var root = input.closest('[data-wk-discount]');
    if (root) { e.preventDefault(); apply(root); }
  });

  // After the /discount/CODE redirect, report the result in every box once.
  function bind(scope) {
    var tried = takeTried();
    if (!tried) return;
    (scope || document).querySelectorAll('[data-wk-discount]').forEach(function (root) {
      reportResult(root, tried);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { bind(document); });
  if (document.readyState !== 'loading') bind(document);
})();
